import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import '../quiz/quiz.css'
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import apiRequest, { FILE_PATH } from "../../../api/api.js";

export const BASEURL = process.env.REACT_APP_BASE_URL_ROOT;

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
};

export default function Registration() {
    const { slug } = useParams();
    console.log(slug);

    const [quizbanners, setQuizBanners] = useState(null);

    useEffect(() => {
        if (slug) {
            fetchQuizBanners();
        }
    }, [slug]);

    const fetchQuizBanners = async () => {
        try {
            const response = await apiRequest.get(`/quiz/${slug}`);
            console.log("quizbanner", response);

            setQuizBanners(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const downloadAllResources = async () => {
        const zip = new JSZip();

        try {
            await Promise.all(
                quizbanners.downloads.map(async (item) => {
                    const response = await fetch(
                        `${FILE_PATH}${item.file_path}`
                    );

                    const blob = await response.blob();

                    zip.file(item.file_name + ".pdf", blob);
                })
            );

            const zipBlob = await zip.generateAsync({ type: "blob" });

            saveAs(zipBlob, "Learning-Materials.zip");
        } catch (error) {
            console.error("Error downloading files:", error);
        }
    };

    return (
        <div className="main">
            <div className="registration-banner">
                <Slider {...settings}>
                    <div className="hero-single-slide">
                        <a
                            href={quizbanners?.googleurl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-block h-100"
                        >
                            {quizbanners && (
                                <picture>
                                    {/* Mobile Banner */}
                                    <source
                                        media="(max-width: 767px)"
                                        srcSet={`${FILE_PATH}${quizbanners.mobile}`}
                                    />

                                    {/* Tablet Banner */}
                                    <source
                                        media="(max-width: 1024px)"
                                        srcSet={`${FILE_PATH}${quizbanners.tablet}`}
                                    />

                                    {/* Desktop Banner */}
                                    <img
                                        src={`${FILE_PATH}${quizbanners.banner}`}
                                        alt={quizbanners.title || "Banner"}
                                        style={{
                                            width: "100%",
                                            display: "block",
                                        }}
                                    />
                                </picture>
                            )}
                        </a>
                    </div>
                </Slider>
            </div>
            <section className="quick-stats-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="stats-title fw-bold mb-2">
                            Quiz at a Glance
                        </h2>

                        <p className="stats-description mb-0">
                            Everything you need to know before you begin
                        </p>
                    </div>

                    <div className="row g-4 justify-content-center">

                        <div className="col-6 col-md-6 col-lg-3">
                            <div className="stat-card text-center h-100">

                                <img src={BASEURL + "assets/images/state-1.png"}
                                    alt="Classes"
                                    className="img-fluid stat-icon" />
                                <p className="stat-label mb-0">
                                    Classes
                                </p>

                                <h3 className="stat-value mb-2">
                                    {quizbanners?.classes}
                                </h3>


                            </div>
                        </div>

                        <div className="col-6 col-md-6 col-lg-3">
                            <div className="stat-card text-center h-100">

                                <img src={BASEURL + "assets/images/state-4.png"}
                                    alt="Questions"
                                    className="img-fluid stat-icon" />
                                <p className="stat-label mb-0">
                                    Questions
                                </p>
                                <h3 className="stat-value mb-2">
                                    {quizbanners?.questions}
                                </h3>



                            </div>
                        </div>

                        <div className="col-6 col-md-6 col-lg-3">
                            <div className="stat-card text-center h-100">

                                <img src={BASEURL + "assets/images/state-2.png"}
                                    alt="Duration"
                                    className="img-fluid stat-icon" />
                                <p className="stat-label mb-0">
                                    Duration
                                </p>
                                <h3 className="stat-value mb-2">
                                    {quizbanners?.duration}
                                </h3>



                            </div>
                        </div>

                        <div className="col-6 col-md-6 col-lg-3">
                            <div className="stat-card text-center h-100">

                                <img src={BASEURL + "assets/images/state-3.png"}
                                    alt="Mode"
                                    className="img-fluid stat-icon" />
                                <p className="stat-label mb-0">
                                    Mode
                                </p>
                                <h3 className="stat-value mb-2">
                                    {quizbanners?.testmode}
                                </h3>



                            </div>
                        </div>



                    </div>

                </div>
            </section>
            <section className="about-quiz-section py-5">
                <div className="container">

                    <div className="text-center mb-5">
                        <h2 className="about-title fw-bold mb-3">
                            About the Quiz
                        </h2>

                        <p className="about-description mx-auto mb-0">
                            {new DOMParser()
                                .parseFromString(quizbanners?.about || "", "text/html")
                                .documentElement.textContent}
                        </p>
                    </div>

                    <div className="row align-items-center gy-5">


                        <div className="col-lg-7">
                            {quizbanners?.about_topics
                                ?.split("\r\n")
                                .filter((item) => item.trim() !== "")
                                .map((topic, index) => (
                                    <div
                                        className={`d-flex align-items-center ${index !== quizbanners.about_topics.split("\r\n").filter((item) => item.trim() !== "").length - 1
                                            ? "mb-4"
                                            : ""
                                            }`}
                                        key={index}
                                    >
                                        <div className="feature-icon">
                                            <img src={BASEURL + "assets/images/tick.png"} alt="" />
                                        </div>

                                        <h3 className="feature-text mb-0 ms-3">
                                            {topic}
                                        </h3>
                                    </div>
                                ))}
                        </div>

                        <div className="col-lg-5 text-center">

                            <div className="about-image-wrapper">
                                <img src={BASEURL + "assets/images/About the Quiz Section.png"}
                                    alt="About Quiz"
                                    className="img-fluid about-image" />
                            </div>

                        </div>

                    </div>

                </div>
            </section>
            <section className="expect-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="expect-title fw-bold mb-3">
                            What to Expect?
                        </h2>

                        <p className="expect-description mx-auto mb-0">
                            The quiz includes multiple-choice, concept-based, application-based and logical reasoning questions.
                        </p>
                    </div>
                    <div className="row g-4 justify-content-center">
                        <div className="col-6 col-md-4 col-lg-2">
                            <div className="expect-card expect-card-blue text-center h-100">

                                <img src={BASEURL + "assets/images/Multiple-choice.png"}
                                    className="img-fluid expect-image"
                                    alt="MCQ" />

                                <h3 className="expect-card-title">
                                    Multiple Choice
                                    Questions
                                </h3>

                                <div className="expect-divider expect-divider-blue mx-auto"></div>

                            </div>
                        </div>

                        <div className="col-6 col-md-4 col-lg-2">
                            <div className="expect-card expect-card-green text-center h-100">

                                <img src={BASEURL + "assets/images/Logical-Reasoning-Puzzles.png"}
                                    className="img-fluid expect-image"
                                    alt="Logical" />

                                <h3 className="expect-card-title">
                                    Logical Reasoning
                                    Puzzles
                                </h3>

                                <div className="expect-divider expect-divider-green mx-auto"></div>

                            </div>
                        </div>

                        <div className="col-6 col-md-4 col-lg-2">
                            <div className="expect-card expect-card-orange text-center h-100">

                                <img src={BASEURL + "assets/images/Application-Based-Problems.png"}
                                    className="img-fluid expect-image"
                                    alt="Application" />

                                <h3 className="expect-card-title">
                                    Application Based
                                    Problems
                                </h3>

                                <div className="expect-divider expect-divider-orange mx-auto"></div>

                            </div>
                        </div>

                        <div className="col-6 col-md-4 col-lg-2">
                            <div className="expect-card expect-card-purple text-center h-100">

                                <img src={BASEURL + "assets/images/Data-interpretation-Question.png"}
                                    className="img-fluid expect-image"
                                    alt="Data" />

                                <h3 className="expect-card-title">
                                    Visual Interpretation Question
                                </h3>

                                <div className="expect-divider expect-divider-purple mx-auto"></div>

                            </div>
                        </div>


                        <div className="col-6 col-md-4 col-lg-2">
                            <div className="expect-card expect-card-pink text-center h-100">

                                <img src={BASEURL + "assets/images/Conceptual-Questions.png"}
                                    className="img-fluid expect-image"
                                    alt="Conceptual" />

                                <h3 className="expect-card-title">
                                    Conceptual<br />
                                    Questions
                                </h3>

                                <div className="expect-divider expect-divider-pink mx-auto"></div>

                            </div>
                        </div>

                        <div className="col-6 col-md-4 col-lg-2">
                            <div className="expect-card expect-card-yellow text-center h-100">

                                <img src={BASEURL + "assets/images/Time-bound-Assessment.png"}
                                    className="img-fluid expect-image"
                                    alt="Time Bound" />

                                <h3 className="expect-card-title">
                                    Time-bound
                                    Assessment
                                </h3>

                                <div className="expect-divider expect-divider-yellow mx-auto"></div>

                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <section className="participate-section py-5">
                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-5">

                            <div className="participate-image-wrapper text-center">
                                <img
                                    src={BASEURL + "assets/images/students.png"}
                                    alt="Student"
                                    className="img-fluid participate-image" />
                            </div>

                        </div>

                        <div className="col-lg-7">

                            <div className="mb-5">

                                <h2 className="participate-title fw-bold mb-3">
                                    Who can Participate
                                </h2>

                                <p className="participate-description mb-0">
                                    The quiz is open to students from Grades 1 to 8 studying in recognised schools. The assessment is designed to provide an engaging, age-appropriate learning experience for every participant.
                                </p>

                            </div>

                            <div className="row g-4">

                                <div className="col-md-6">

                                    <div className="participate-card participate-card-blue d-flex align-items-center">

                                        <div className="participate-icon participate-icon-blue">
                                            <img src={BASEURL + "assets/images/Participate4.png"}
                                                alt=""
                                                className="img-fluid" />
                                        </div>

                                        <div className="ms-3 flex-grow-1">

                                            <h4 className="participate-card-title mb-2">
                                                Participants must attempt
                                                the quiz individually
                                            </h4>

                                            <div className="participate-divider participate-divider-blue"></div>

                                        </div>

                                    </div>

                                </div>
                                <div className="col-md-6">

                                    <div className="participate-card participate-card-green d-flex align-items-center">

                                        <div className="participate-icon participate-icon-green">
                                            <img src={BASEURL + "assets/images/Participate3.png"}
                                                alt=""
                                                className="img-fluid" />
                                        </div>

                                        <div className="ms-3 flex-grow-1">

                                            <h4 className="participate-card-title mb-2">
                                                Use of unfair means or
                                                assistance is not allowed
                                            </h4>

                                            <div className="participate-divider participate-divider-green"></div>

                                        </div>

                                    </div>

                                </div>

                                <div className="col-md-6">

                                    <div className="participate-card participate-card-orange d-flex align-items-center">

                                        <div className="participate-icon participate-icon-orange">
                                            <img src={BASEURL + "assets/images/Participate2.png"}
                                                alt=""
                                                className="img-fluid" />
                                        </div>

                                        <div className="ms-3 flex-grow-1">

                                            <h4 className="participate-card-title mb-2">
                                                Follow all instructions
                                                carefully
                                            </h4>

                                            <div className="participate-divider participate-divider-orange"></div>

                                        </div>

                                    </div>

                                </div>
                                <div className="col-md-6">

                                    <div className="participate-card participate-card-purple d-flex align-items-center">

                                        <div className="participate-icon participate-icon-purple">
                                            <img src={BASEURL + "assets/images/Participate1.png"}
                                                alt=""
                                                className="img-fluid" />
                                        </div>

                                        <div className="ms-3 flex-grow-1">

                                            <h4 className="participate-card-title mb-2">
                                                All decisions by VOLT
                                                Learning are final
                                            </h4>

                                            <div className="participate-divider participate-divider-purple"></div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>
            <section className="resources-section py-5">
                <div className="container">

                    <div className="text-center mb-5">
                        <h2 className="section-title fw-bold mb-3">
                            Your Learning Journey
                        </h2>

                        <p className="section-description mb-0">
                            Access learning resources, explore rewards, and find all the important information before you begin.
                        </p>
                    </div>

                    <div className="row g-4">

                        <div className="col-lg-4">

                            <div className="info-card-purple-outer h-100">
                                <div className="info-card info-card-purple h-100">

                                    <div className="d-flex justify-content-between align-items-start mb-4">
                                        <div>
                                            <h3 className="card-title mb-2">
                                                Download <br />
                                                Learning Materials
                                            </h3>

                                            <div className="title-divider divider-purple"></div>
                                        </div>

                                        <img
                                            src={BASEURL + "../assets/images/materials.png"}
                                            className="img-fluid section-icon"
                                            alt=""
                                        />
                                    </div>

                                    {quizbanners?.downloads?.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`resource-item ${index !== quizbanners.downloads.length - 1
                                                ? "mb-3"
                                                : "mb-4"
                                                }`}
                                        >
                                            <div className="d-flex align-items-center w-100">

                                                <img
                                                    src={BASEURL + "../assets/images/pdf.png"}
                                                    className="resource-icon"
                                                    alt=""
                                                />

                                                <div className="ms-3 flex-grow-1">
                                                    <h5 className="resource-title mb-1">
                                                        {item.file_name}
                                                    </h5>

                                                    <span className="resource-meta">
                                                        PDF
                                                    </span>
                                                </div>

                                                <a
                                                    href={`${FILE_PATH}${item.file_path}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="download-icon"
                                                >
                                                    <img
                                                        src={BASEURL + "../assets/images/download.png"}
                                                        className=""
                                                        alt=""
                                                    />
                                                </a>

                                            </div>
                                        </div>
                                    ))}

                                    {quizbanners?.downloads?.length > 0 && (
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                downloadAllResources();
                                            }}
                                            className="btn download-all-btn w-100"
                                        >
                                            Download All Resources
                                            <img
                                                src={BASEURL + "assets/images/download-white.png"}
                                                className="resource-icon ms-2"
                                                alt=""
                                            />
                                        </a>
                                    )}

                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4">

                            <div className="info-card info-card-orange h-100">

                                <div className="d-flex justify-content-between align-items-start mb-4">
                                    <div>
                                        <h3 className="card-title mb-2">
                                            Rewards & <br />
                                            Recognition
                                        </h3>
                                        <div className="title-divider divider-orange"></div>
                                    </div>

                                    <img
                                        src={BASEURL + "assets/images/Rewards.png"}
                                        className="img-fluid section-icon"
                                        alt=""
                                    />
                                </div>

                                {quizbanners?.rewards?.map((reward, index) => (
                                    <div
                                        key={index}
                                        className={`reward-item ${index !== quizbanners.rewards.length - 1 ? "mb-3" : ""
                                            }`}
                                    >
                                        <img
                                            src={BASEURL + `assets/images/Rewards_${index + 1}.png`}
                                            alt={reward.reward_name}
                                        />

                                        <div className="ms-3">
                                            <h5>{reward.reward_name}</h5>
                                            <p className="mb-0">
                                                {reward.reward_description}
                                            </p>
                                        </div>
                                    </div>
                                ))}

                            </div>

                        </div>
                        <div className="col-lg-4">

                            <div className="info-card info-card-green h-100">

                                <div className="d-flex justify-content-between align-items-start mb-4">
                                    <div>
                                        <h3 className="card-title mb-2">
                                            Important <br />
                                            Information
                                        </h3>

                                        <div className="title-divider divider-green"></div>
                                    </div>

                                    <img
                                        src={BASEURL + "assets/images/Important.png"}
                                        className="img-fluid section-icon"
                                        alt=""
                                    />
                                </div>

                                {quizbanners?.important_points?.map((item, index) => (
                                    <div
                                        className={`info-item ${index !== quizbanners.important_points.length - 1 ? "mb-3" : ""
                                            }`}
                                        key={index}
                                    >
                                        <img
                                            src={
                                                BASEURL +
                                                (
                                                    index === 0
                                                        ? "assets/images/calendar_month.png"
                                                        : index === 1
                                                            ? "assets/images/schedule.png"
                                                            : index === 2
                                                                ? "assets/images/computer.png"
                                                                : "assets/images/earth.png"
                                                )
                                            }
                                            alt=""
                                        />

                                        <div className="ms-3">
                                            <h5>{item.important_name}</h5>
                                            <p className="mb-0">{item.important_description}</p>
                                        </div>
                                    </div>
                                ))}

                            </div>

                        </div>

                    </div>

                </div>
            </section>
            <section className="quiz-cta-section py-5">
                <div className="container">

                    <div className="quiz-cta-wrapper position-relative overflow-hidden">

                        <div className="row align-items-center g-4">

                            <div className="col-lg-4 text-center">

                                <img
                                    src={BASEURL + "assets/images/REGISTER-NOW-IMAGE.png"}
                                    alt="Math Quiz"
                                    className="img-fluid cta-book-image" />

                            </div>
                            <div className="col-lg-6">

                                <h2 className="cta-title fw-bold mb-4">
                                    Ready to test your computer and thinking skills?
                                </h2>

                                <p className="cta-description mb-4">
                                    Register now and take the next step
                                    in your learning journey.
                                </p>

                                <a href={quizbanners?.googleurl}
                                    className="btn cta-btn">

                                    Register Now

                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="ms-2"
                                        viewBox="0 0 16 16">

                                        <path fill-rule="evenodd"
                                            d="M1 8a.75.75 0 0 1 .75-.75h10.69L8.22 3.03a.75.75 0 1 1 1.06-1.06l5.5 5.5a.75.75 0 0 1 0 1.06l-5.5 5.5a.75.75 0 1 1-1.06-1.06l4.22-4.22H1.75A.75.75 0 0 1 1 8z" />
                                    </svg>

                                </a>

                            </div>
                            <div className="col-lg-2 d-none d-lg-block">

                                <div className="paper-plane-wrapper">
                                    <img
                                        src={BASEURL + "assets/images/flying_paper.svg"}
                                        alt=""
                                        className="img-fluid" />
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>
        </div>
    )
}